var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRevenues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2,.cls-4{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:25px;}.cls-2{fill:none;}.cls-3{font-size:284.14px;font-family:MyriadPro-Regular, Myriad Pro;}.cls-4{fill:#f8f8f8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M925.38,363.59h48a66.29,66.29,0,0,1,66.29,66.29V781.7A66.29,66.29,0,0,1,973.35,848H106.65a66.29,66.29,0,0,1-66.29-66.3V429.88a66.29,66.29,0,0,1,66.29-66.29h712.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 540,
    cy: 605.79,
    r: 180.63
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(465.68 706) scale(1.09 1)"
  }, "S"), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 540,
    y1: 483.84,
    x2: 540,
    y2: 737.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 871.28,
    y1: 487.77,
    x2: 871.28,
    y2: 239.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M837.27,281.44l26.24-44.37c4-6.75,11.52-6.75,15.51,0l26.26,44.38"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevenues);
export default __webpack_public_path__ + "static/media/ICON_Revenues.1df9a71453d6670277cedc91fb0d9f6d.svg";
export { ForwardRef as ReactComponent };